import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

interface Request {
  invitationToken: string;
  userId: string;
}
export default function joinWorkspaceByInvitation(payload: Request) {
  return API.post<
    ResponseBaseWithData<{
      workspaceName: string;
      accessToken: string;
      workspaceId: string;
      workspaceType: 'TAX_AGENT' | 'COMPANY';
    }>
  >(`/api/v2/users/${payload.userId}/join-workspace-by-invitation`, {
    data: {
      invitationToken: payload.invitationToken,
    },
  });
}
